import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getProjects, getError, getIsLoading } from 'store/selectors/projects';
import { addProject, editProject, deleteProject } from 'store/actions/projects';
import Projects from './Projects';

const selector = createStructuredSelector({
  isLoading: getIsLoading,
  error: getError,
  projects: getProjects,
});

const actions = {
  onAddProject: addProject,
  onEditProject: editProject,
  onDeleteProject: deleteProject,
};

export default connect(
  selector,
  actions,
)(Projects);
